import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

const UnifiedCardTimer = ({project, startTime, endTime,timeshow, setTimeshow}) => {
    const { t } = useTranslation();

    const [day, setDay] = useState(0);
    const [hour, setHour] = useState(0);
    const [min, setMin] = useState(0);
    const [sec, setSec] = useState(0);
    const [day1, setDay1] = useState(0);
    const [hour1, setHour1] = useState(0);
    const [min1, setMin1] = useState(0);
    const [sec1, setSec1] = useState(0);

    // Timer logic for live projects
    useEffect(() => {
        if (project.saleType !== 'live' || !startTime) return;

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const time = startTime;
            const diff = time - now;
            if (diff <= 0) {
                clearInterval(interval);
                setTimeshow(true);
                return;
            }
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const secs = Math.floor((diff % (1000 * 60)) / 1000);
            setDay1(days);
            setHour1(hours);
            setMin1(mins);
            setSec1(secs);
        }, 1000);
        return () => clearInterval(interval);
    }, [project.saleType, startTime]);
        
    useEffect(() => {
        if (project.saleType !== 'live' || !endTime ) return;

        const interval = setInterval(() => {
            const now = new Date().getTime();
            const time = endTime;
            const diff = time - now;
            if (diff <= 0) {
                clearInterval(interval);
                setTimeshow(true);
                return;
            }
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const secs = Math.floor((diff % (1000 * 60)) / 1000);
            setDay(days);
            setHour(hours);
            setMin(mins);
            setSec(secs);
        }, 1000);
        return () => clearInterval(interval);
    }, [project.saleType, endTime]);

  return (
    <>
      <h6>{!timeshow ? <>{t('Process-t13')}</> : <>{t('Process-t10')}</>}</h6>
        {!timeshow ? (
            <h6>
                {day1 ? day1 : 0}D : {hour1 ? hour1 : 0}H :{" "}
                {min1 ? min1 : 0}M : {sec1 ? sec1 : 0}S
            </h6>
        ) : (
            <h6>
                {day ? day : 0}D : {hour ? hour : 0}H : {min ? min : 0}M
                : {sec ? sec : 0}S
            </h6>
        )}
    </>
  )
}

export default UnifiedCardTimer
